module.exports = __webpack_public_path__ + "img/Blue Marble.a7ecc6f7.jpg";